module.exports = __webpack_public_path__ + "static/media/laptop.bbc825c3.svg";